import { NRLogger as t } from './contact-channels45.js';

const n=async(t$1,s,r)=>{const e=await fetch(`https://c2c-service.care.vpsvc.com/v1/countries/tenants/${t$1}/locales/${s}/segments/${r}?requestor=ContactChannelsLib`,{method:"GET",headers:{Accept:"application/json"}});if(!e.ok)throw t.error("Contact Channels: Available Countries",{status:e.status,message:"Failed to fetch Available Countries from C2C Service"}),new Error(`HTTP error! Status: ${e.status}`);return e.json()};

export { n as getAvailableCountries };
//# sourceMappingURL=contact-channels72.js.map
